module.exports = __webpack_public_path__ + "static/media/worry-time-large@2x.eb6a7258.png";